export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo3-3e422525ddfb3fe997020435d9b4e2d6.jpg";